<div class="ui-header">
  <div class="breadcrumb" [dir]="documentDirection$ | async">
    <ng-container *ngFor="let item of selectBreadcrumbs; let idx = index">
      <a
        *ngIf="!!item?.route; else noLink"
        class="link"
        routerLink="{{ item.route }}"
        fragment="{{ item.fragment }}"
        [queryParams]="item.queryParams"
      >
        <span class="name">{{ item.name | translate }}</span>
      </a>
      <ng-template #noLink>
        <div class="page flex-row start-center">
          <span class="name" uiTruncateText>{{ item.name | translate }}</span>
        </div>
      </ng-template>
      <span
        class="ui-icon-expand-arrow"
        *ngIf="idx !== selectBreadcrumbs.length - 1"
      ></span>
    </ng-container>
  </div>

  <div class="ui-header-content">
    <ng-content> </ng-content>
  </div>
</div>
